import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import { AuthProvider } from './components/auth';
import {
  HomePageSEO,
  AboutSEO,
  TradeCodesSEO,
  TechnologyTypesSEO,
  SystemsSEO,
  CompaniesSEO,
  AuthSEO,
  GenericPageSEO,
} from './components/SEOWrapper';
import AboutPage from './components/AboutPage';
import WebinarPage from './components/WebinarPage';

/**
 * Prerender-only app shell for react-snap.
 *
 * Goal: render route-specific meta tags/JSON-LD without triggering
 * auth initialization or data-fetching side effects that require a backend.
 */
const PrerenderApp: React.FC = () => {
  const theme = createTheme({ palette: { mode: 'light' } });

  return (
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AuthProvider>
          <Routes>
            <Route path="/about" element={<AboutSEO><AboutPage /></AboutSEO>} />
            <Route
              path="/webinar"
              element={
                <GenericPageSEO
                  title="Webinar"
                  description="Webinar information and resources for the Productive Capabilities Data Lab."
                >
                  <WebinarPage />
                </GenericPageSEO>
              }
            />

            {/* Public routes: render minimal placeholders to avoid backend calls */}
            <Route path="/trade-codes" element={<TradeCodesSEO><div /></TradeCodesSEO>} />
            <Route path="/technology-types" element={<TechnologyTypesSEO><div /></TechnologyTypesSEO>} />
            <Route path="/systems" element={<SystemsSEO><div /></SystemsSEO>} />
            <Route path="/companies" element={<CompaniesSEO><div /></CompaniesSEO>} />
            <Route
              path="/downstream-potential"
              element={
                <GenericPageSEO
                  title="Downstream Potential"
                  description="Explore downstream potential across value chains."
                >
                  <div />
                </GenericPageSEO>
              }
            />

            {/* Auth route: noindex */}
            <Route path="/auth" element={<AuthSEO><div /></AuthSEO>} />

            {/* Home: use homepage schemas */}
            <Route path="/" element={<HomePageSEO><AboutPage /></HomePageSEO>} />
            <Route path="*" element={<Navigate to="/about" replace />} />
          </Routes>
        </AuthProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
};

export default PrerenderApp;

